/*
 * @Author: your name
 * @Date: 2024-07-08 16:24:48
 * @LastEditTime: 2024-07-09 09:50:13
 * @LastEditors: your name
 * @Description: 
 * @FilePath: \web_BullyingPrevention\src\http\moudules\county.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import axios from '../axios'
//查询教育局下的下的所有事件
export const getallEvent = (data) => {
    return axios({
      url: '/area/event',
      method: 'post',
      data
    })
  }
  //查询学校下的所有位置
  export const getAllSchool = (schoolId) => {
    return axios({
      url: `/area/getAllSchool?schoolId=${schoolId}`,
      method: 'get',
    })
  }
    //查询学校下的乡镇
  export const getAllTown = (schoolId) => {
      return axios({
        url: `/area/getAllTown?schoolId=${schoolId}`,
        method: 'get',
      })
  }
  //获取学校的数量
  export const schoolDeviceCount = (schoolId) => {
      return axios({
        url: `/area/schoolDeviceCount?schoolId=${schoolId}`,
        method: 'get',
      })
  }
  //获取区县的学生数量
  export const studentCount = (schoolId) => {
      return axios({
        url: `/area/studentCount?schoolId=${schoolId}`,
        method: 'get',
      })
  }
  //获取区县事件趋势
  export const eventTrend = (schoolId) => {
    return axios({
        url: `/area/eventTrend?schoolId=${schoolId}`,
        method: 'get',
      })
  }
    //学校事件类型；source=1 名厨亮灶，未传则防霸凌
    export const eventSchoolType = (schoolId, source) => {
      let url = `/area/eventSchoolType?schoolId=${schoolId}`
      if (source != null && source !== '') {
        url += `&source=${source}`
      }
      return axios({
          url,
          method: 'get',
        })
    }
     //学校数量排行榜；source=1 名厨亮灶，未传则防霸凌
     export const schoolEventRank = (schoolId, count, source) => {
      let url = `/area/schoolEventRank?schoolId=${schoolId}&count=${count}`
      if (source != null && source !== '') {
        url += `&source=${source}`
      }
      return axios({
          url,
          method: 'get',
        })
    }
  /** 近一年行为分析统计（堆叠图等） */
  export const getBehaviorEventStatistics = (schoolId, type = 8) => {
    return axios({
      url: `/area/getBehaviorEventStatistics?schoolId=${schoolId}&type=${type}`,
      method: 'get'
    })
  }
  /** 学校监控通道列表（轮播 RTSP） */
  export const getSchoolCameraChannelList = (schoolId, type = 8) => {
    return axios({
      url: `/area/getSchoolCameraChannelList?schoolId=${schoolId}&type=${type}`,
      method: 'get'
    })
  }

       //获取镇下面的学校
       export const schoolByTownId = (schoolId,townId) => {
        return axios({
            url: `/area/schoolByTownId?schoolId=${schoolId}&townId=${townId}`,
            method: 'get',
          })
      }
      //导出查询记录

      export const getallEventExport = (data) => {
        return axios({
          url: '/area/export',
          method: 'post',
          data
        })
      }